import { CsvBuilder } from 'filefy'

export const exportCsv = (
  rows = [],
  { columnNames = null, fileName = 'export.csv' } = {}
) => {
  if (!fileName.endsWith('.csv')) {
    fileName = fileName + '.csv'
  }

  const builder = new CsvBuilder(fileName)
  builder.setDelimeter(',')

  if (columnNames && columnNames.length) {
    builder.setColumns(columnNames)
  }

  builder.addRows(rows).exportFile()
}
